var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#25A3E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16614 10.1864C5.29146 9.57403 6.54764 9.06294 7.72135 8.54924C9.74058 7.70784 11.7678 6.88102 13.8155 6.11126C14.214 5.9801 14.9298 5.85184 15 6.43512C14.9616 7.26075 14.8035 8.08154 14.695 8.90234C14.4197 10.7073 14.1016 12.5062 13.7913 14.3052C13.6844 14.9045 12.9245 15.2147 12.4383 14.8312C11.2698 14.0515 10.0923 13.2793 8.93877 12.4815C8.56089 12.1022 8.9113 11.5575 9.24879 11.2866C10.2112 10.3496 11.2318 9.55354 12.1439 8.56814C12.39 7.98117 11.663 8.47585 11.4232 8.62742C10.1057 9.52438 8.82041 10.4761 7.43131 11.2644C6.72176 11.6503 5.89476 11.3205 5.18553 11.1052C4.54962 10.8451 3.61777 10.583 4.16607 10.1864L4.16614 10.1864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.11a1cbf02940af903912da9ba955aa93.svg";
export { ForwardRef as ReactComponent };